module.exports = __webpack_public_path__ + "static/media/Sustainability_white.cd1332d2.svg";